import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectLocked } from '../selectors/device.selector';

@Service()
export class DeviceFacade {
    private readonly store = inject(Store);

    readonly locked = this.store.selectSignal(selectLocked);
}
